export default __webpack_public_path__ + "static/media/ripple.85e15ac8.svg";